export default "__VITE_ASSET__aI58wNxY__"